import { Link } from 'react-router-dom'
import { PageBreadcrumb } from '@/components/ui/PageBreadcrumb'
import { SubscribeCta } from '@/components/website/SubscribeCta'
import { useWebsiteServices } from '@/services/httpServices/queries/useWebsite'

export function Services() {
  const { services } = useWebsiteServices()

  return (
    <>
      <PageBreadcrumb title="Services" />

      <section className="services-section-1 pt-100 md-pt-80 pb-100 md-pb-80">
        <div className="container">
          <div className="row">
            {services.map((service) => (
              <div className="col-xl-4 col-lg-6 col-md-6" key={service.slug}>
                <div className="service-items background-one">
                  <div className="service-icon">
                    <figure>
                      <img src={service.icon} alt={`${service.title} icon`} />
                    </figure>
                  </div>
                  <div className="service-content">
                    <h2>
                      <Link to={`/services/${service.slug}`}>{service.title}</Link>
                    </h2>
                    <p>{service.description}</p>
                    <Link to={`/services/${service.slug}`} className="read-more-btn">
                      More Details
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SubscribeCta />
    </>
  )
}
